
// @ts-nocheck # 忽略全文

import { Options, Vue } from 'vue-class-component'
import { mapState } from 'vuex'
import pg1 from "@/assets/img/share/share_post_bg.png"
import pg2 from "@/assets/img/share/share_style@2x.png"
import pg3 from "@/assets/img/share/share_style_head@2x.png"
import pg5 from "@/assets/img/share/code.png"
import pg6 from "@/assets/img/share/share_icom_location@2x.png"
import pg8 from "@/assets/img/share/share_word_bg@2x.png"
import vueCanvasPoster from 'vue-canvas-poster'
import moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    data() {

        return {
            codeImg: pg1,
            dataURL: "",

            posterImg: "",
            testimg: "../assets/img/man.jpg",
            name: "",
            modelimg: [
                { style: require('../assets/img/share/share_modle_jian20@2x.png'), auth: require('../assets/img/share/share_chapter_kongtian@2x.png'), nameurl: require('../assets/img/share/share_word_.png') },
                { style: require('../assets/img/share/share_modle_shanghai@2x.png'), auth: require('../assets/img/share/share_chapter_ludi@2x.png'), nameurl: require('../assets/img/share/share_word_shanghai.png') },
                { style: require('../assets/img/share/share_modle_tiangong@2x.png'), auth: require('../assets/img/share/share_chapter_kongtian@2x.png'), nameurl: require('../assets/img/share/share_word_tiangong.png') },
                { style: require('../assets/img/share/share_modle_shandong@2x.png'), auth: require('../assets/img/share/share_chapter_haiyang@2x.png'), nameurl: require('../assets/img/share/share_word_shandong.png') },
                { style: require('../assets/img/share/share_modle_fuxinghao@2x.png'), auth: require('../assets/img/share/share_chapter_ludi@2x.png'), nameurl: require('../assets/img/share/share_word_fuxing.png') },
                { style: require('../assets/img/share/share_modle_tianfu@2x.png'), auth: require('../assets/img/share/share_chapter_ludi@2x.png'), nameurl: require('../assets/img/share/share_word_tianfu.png') },
                { style: require('../assets/img/share/share_modle_gangzhuao@2x.png'), auth: require('../assets/img/share/share_chapter_haiyang@2x.png'), nameurl: require('../assets/img/share/share_word_gangzhuao.png') },
                { style: require('../assets/img/share/share_modle_mengxiangjia@2x.png'), auth: require('../assets/img/share/share_chapter_mengxiang@2x.png'), nameurl: require('../assets/img/share/share_word_mengxiangjia.png') },
            ],
            provincedata: {
                "北京市": "tjbj",
                "上海市": "tjsh",
                "重庆市": "tjcq",
                "天津市": "tjtj",
                "河北省": "tjhe",
                "山西省": "tjsx",
                "内蒙古自治区": "tjnm",
                "辽宁省": "tjln",
                "吉林省": "tjjl",
                "黑龙江省": "tjhl",
                "江苏省": "tjjs",
                "浙江省": "tjzj",
                "安徽省": "tjah",
                "福建省": "tjfj",
                "江西省": "tjjx",
                "山东省": "tjsd",
                "河南省": "tjha",
                "湖北省": "tjhb",
                "湖南省": "tjhn",
                "广东省": "tjgd",
                "广西壮族自治区": "tjgx",
                "海南省": "tjhi",
                "四川省": "tjsc",
                "贵州省": "tjgz",
                "云南省": "tjyn",
                "西藏自治区": "tjxz",
                "陕西省": "tjsn",
                "甘肃省": "tjgs",
                "青海省": "tjqh",
                "宁夏回族自治区": "tjnx",
                "新疆维吾尔自治区": "tjxj"
            },
            status: false,
        };
    },
    props: {
        showPoster: false,
        hidePoster: false,
    },
    watch: {
        status(nstat, ostat) {
            // if (nstat == true) {
            //     console.log("执行");
            //     this.poster()
            // }
        }
    },
    components: { vueCanvasPoster },
    created() {
        // this.imgload()
        this.getGameinfo()

    },
    computed: {
        ...mapState(['userInfo', 'shareData', 'activityData', 'GetUserParams'])
    },
    mounted() {
        this.$common.pageLoaded()
        let homeShareData = JSON.parse(JSON.stringify(this.shareData))
        homeShareData.link = window.location.href
        if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
            let shareword = document.getElementById("shareword")
            let sharebutton = document.getElementById("sharebutton")
            if (sharebutton != null && shareword != null) {
                sharebutton.style.display = ""
                shareword.style.display = "none"
            }
        }
        this.poster()
        // 
        // this.$common.onshare(homeShareData)
        // this.$common.track('load', '进入首页')


    },
    methods: {
        shareimg() {
            if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
                let homeShareData = JSON.parse(JSON.stringify(this.shareData))
                let imgsrc = this.posterImg
                let imgjson = {
                    "title": homeShareData.title,
                    "desc": homeShareData.desc,
                    "link": homeShareData.link,
                    "imgUrl": "https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20220913/34D71F8C-E002-819A-3288-4A9C1547BCD1.png",
                    "image": imgsrc.split(';base64,')[1],
                    "callback": function (status) {
                        if (status == 1) {
                            this.$common.toast("分享成功")
                        }
                        if (status == 0) {
                            this.$common.toast("分享取消")
                        }
                    }
                }
                COVERAPP.Method.shareImage(imgjson)
            }

        },
        // 海报生成
        poster() {
            let inviCanvas = document.createElement("canvas")
            let invictx = inviCanvas.getContext("2d")
            inviCanvas.width = 900;
            inviCanvas.height = 1755;
            let usr = sessionStorage.getItem('COVER_USERINFO')
            var user
            if (usr != null) {
                user = JSON.parse(usr)
            }
            this.name = user.nickname
            const { templateConfig } = this.activityData
            let day = this.DateDiff();
            const persons = sessionStorage.getItem('GAME_USERINFO')
            let tjtotal = JSON.parse(JSON.stringify(this.provincedata))
            var str4
            if (persons != null) {
                let prov;
                var personscore = JSON.parse(persons)
                if (personscore.province == null || personscore.province == undefined) {
                    prov = tjtotal["四川省"]
                } else {
                    prov = tjtotal[personscore.province]
                }

                let tjBase = prov + "Base"
                let tjRatio = prov + "Ratio"
                var city = personscore.city || "成都市"
                var str = city.substring(0, 2)
                var provincestr = personscore.province || "四川省"
                var str1 = provincestr.substring(0, 2)
                var str2 = Math.round(templateConfig[tjBase] + day * templateConfig[tjRatio])
                console.log("str2", str2);
                var str3 = personscore.rank + 1
                if (str3 == 0) {
                    let allper = Math.floor(templateConfig.tjTotalBase + day * templateConfig.tjTotalRatio)
                    str3 = allper
                }
                if (personscore.rank == -1) {
                    str4 = 1
                } else {
                    str4 = Math.floor((1 - (personscore.rank + 1) / str2) * 100)
                }
            }
            let _this = this;
            let c = document.getElementById('myCanvas') // 画板id
            let p = document.getElementById('poster')
            if (p != null) {
                p.style.display = ""
            }
            let numlen = this.fornum(str4.toString())
            let len = this.forstr(user.nickname)
            let namelen = this.forname(user.nickname)
            if (len > 250) {
                user.nickname=user.nickname.substring(0,10)+"..."
                len= this.forstr(user.nickname)
                namelen = this.forname(user.nickname)
            }

            //尺寸
            c.width = 900;
            c.height = 1755;
            let ctx = c.getContext("2d")
            let img = new Image() // 背景图对象
            var base64 = "" //base64
            //引入线上背景图可能存在跨域问题,解决：
            img.setAttribute("crossOrigin", "anonymous")
            img.src = pg1 // 背景图路经
            //爱国图标
            let img1 = new Image()
            img1.setAttribute("crossOrigin", "anonymous")
            img1.src = pg2
            //头像
            let img2 = new Image()
            img2.setAttribute("crossOrigin", "anonymous")
            img2.src = pg3

            let img4 = new Image()
            img4.setAttribute("crossOrigin", "anonymous")
            img4.src = pg5
            let img5 = new Image()
            img5.setAttribute("crossOrigin", "anonymous")
            img5.src = pg6
            let img6 = new Image()
            img6.setAttribute("crossOrigin", "anonymous")
            img6.src = pg8

            var modelId = Number(localStorage.getItem("modelId"));
            let color_egg = JSON.parse(sessionStorage.getItem("color_egg"))
            if (personscore.completed.length == 7 || color_egg == true) {
                modelId = 7
            }
            let img7 = new Image()
            let img9 = new Image()
            let img10 = new Image()
            let img3 = new Image()

            img3.setAttribute("crossOrigin", "anonymous")
            img7.setAttribute("crossOrigin", "anonymous")
            img9.setAttribute("crossOrigin", "anonymous")
            img3.src = user.headimgurl || user.avatar || require('../assets/img/default_man.png')
            img7.src = this.modelimg[modelId].style
            img9.src = this.modelimg[modelId].auth
            img10.setAttribute("crossOrigin", "anonymous")
            img10.src = this.modelimg[modelId].nameurl
            let posterImges = [{ "img": img, "position": [0, 0, 900, 1755] },
            { "img": img3, "position": [503, 165, 240, 230] },
            { "img": img1, "position": [503, 250, 162, 145] },
            { "img": img2, "position": [687, 140, 73, 60] },
            { "img": img4, "position": [650, 1450, 120, 120] },
            { "img": img7, "position": [35, 440, 840, 800] },
            { "img": img9, "position": [560, 580, 179, 147] },
            { "img": img6, "position": [204, 1440, namelen + 4, 40] },
            { "img": img5, "position": [270, 1345, 30, 30] },
            { "img": img10, "position": [96, 1020, 708, 187] },
            ]
            let num = 0
            for (var i = 0; i <= posterImges.length - 1; i++) {
                let imaa = posterImges[i]["img"]
                let pos = posterImges[i]["position"]
                imaa.onload = function () {
                    num = num + 1
                    if (num == posterImges.length) {
                        console.log("执行");
                        for (var t = 0; t <= posterImges.length - 1; t++) {
                            let imaa1 = posterImges[t]["img"]
                            let pos1 = posterImges[t]["position"]
                            invictx.drawImage(imaa1, pos1[0], pos1[1], pos1[2], pos1[3])
                        }
                        invictx.fillStyle = '#094F8C'
                        invictx.font = '20px "微软雅黑"';
                        invictx.fillText(user.nickname, 500 + ((250 - len) / 2), 420)
                        invictx.fillStyle = '#F6F5F4'
                        invictx.font = 'normal bold 30px "微软雅黑"';
                        invictx.fillText(user.nickname, 208, 1470)
                        //文本1
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText("我在", 200, 1370)
                        //文本2
                        invictx.fillStyle = '#E83C41'
                        invictx.fillText(str, 310, 1370)
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText("为大国工程助力", 380, 1370)
                        //文本3
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText(str1 + "已有" + str2 + "人参与挑战", 200, 1420)
                        //文本4
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText("全国排名", 200, 1520)
                        //文本5
                        invictx.fillStyle = '#E83C41'
                        invictx.fillText("第" + str3 + "位", 320, 1520)
                        //文本6
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText("超过了", 200, 1570)
                        //文本7
                        invictx.fillStyle = '#E83C41'
                        invictx.fillText(str4 + "%", 290, 1570)
                        //文本8
                        invictx.fillStyle = '#094F8C'
                        invictx.fillText("的人", 321 + numlen, 1570)
                        ctx.drawImage(inviCanvas, 0, 0)
                        base64 = c.toDataURL("image/png");
                        _this.posterImg = base64;
                    }
                }
            }
        },
        //计算两个日期差值（天）
        DateDiff() {    //sDate1和sDate2是2006-12-18格式
            let times = moment(this.activityData.serverTime).unix() - moment(this.activityData.templateConfig.tjTime[0]).unix()
            // if (moment(this.activityData.serverTime).unix() <= moment(this.activityData.templateConfig.tjTime[1]).unix()) {
            //     times = moment(this.activityData.serverTime).unix() - moment(this.activityData.templateConfig.tjTime[1]).unix()
            // }
            if (times < 0) {
                times = -times
            }
            return times
        },
        nowDate() {
            let now = new Date()
            var year = now.getFullYear(); //年份
            var month = now.getMonth() + 1; //月份（0-11）
            var date = now.getDate(); //天数（1到31）
            var hour = now.getHours(); //小时数（0到23）
            var minute = now.getMinutes(); //分钟数（0到59）
            var second = now.getSeconds(); //秒数（0到59） 
            return (
                year + "/" + month + "/" + date
            )
        },
        forstr(str) {
            // ordinary for loo
            var pattern1 = new RegExp("[\u4E00-\u9FA5]+");
            var pattern2 = new RegExp("[A-Z]+");
            var pattern3 = new RegExp("[a-z]+");
            var pattern4 = new RegExp("[0-9]+");
            let word = 0
            let num = 0
            let zimu = 0
            let zimubg = 0
            for (let i = 0; i < str.length; i++) {
                if (pattern1.test(str[i])) {
                    word = word + 1
                }
                else if (pattern2.test(str[i])) {
                    zimubg = zimubg + 1
                }
                else if (pattern3.test(str[i])) {
                    zimu = zimu + 1
                }
                else if (pattern4.test(str[i])) {
                    num = num + 1
                } else {
                    zimu = zimu + 1
                }
            }
            let result = word * 20 + num * 12 + zimu * 11 + zimubg * 14
            return result
        },
        fornum(str) {
            // ordinary for loo
            var pattern4 = new RegExp("[0-9]+");
            let num = 0
            for (let i = 0; i < str.length; i++) {
                if (pattern4.test(str[i])) {
                    num = num + 1
                }
            }
            let result = num * 18
            return result
        },
        forname(str) {
            // ordinary for loo
            var pattern1 = new RegExp("[\u4E00-\u9FA5]+");
            var pattern2 = new RegExp("[A-Z]+");
            var pattern3 = new RegExp("[a-z]+");
            var pattern4 = new RegExp("[0-9]+");
            let word = 0
            let num = 0
            let zimu = 0
            let zimubg = 0
            for (let i = 0; i < str.length; i++) {
                if (pattern1.test(str[i])) {
                    word = word + 1
                }
                else if (pattern2.test(str[i])) {
                    zimubg = zimubg + 1
                }
                else if (pattern3.test(str[i])) {
                    zimu = zimu + 1
                }
                else if (pattern4.test(str[i])) {
                    num = num + 1
                } else {
                    zimu = zimu + 1
                }
            }
            let result = word * 30 + num * 19 + zimu * 18 + zimubg * 22
            return result
        },
        imgload() {
            var modelId = Number(localStorage.getItem("modelId"));
            let usr = sessionStorage.getItem('COVER_USERINFO')
            var user
            if (usr != null) {
                user = JSON.parse(usr)
            }
            const persons = sessionStorage.getItem('GAME_USERINFO')
            if (persons != null) {
                var personscore = JSON.parse(persons)
                if (personscore.completed.length == 7) {
                    modelId = 7
                }

            }
            img3.setAttribute("crossOrigin", "anonymous")
            img7.setAttribute("crossOrigin", "anonymous")
            img9.setAttribute("crossOrigin", "anonymous")
            img3.src = user.headimgurl || user.avatar || require('../assets/img/default_man.png')
            img7.src = this.modelimg[modelId].style
            img9.src = this.modelimg[modelId].auth
            img10.setAttribute("crossOrigin", "anonymous")
            img10.src = this.modelimg[modelId].nameurl



        },
        async getGameinfo() {
            let usr = sessionStorage.getItem('COVER_USERINFO')
            var user
            if (usr != null) {
                user = JSON.parse(usr)
            }
            let usrdata = await this.$request('/temporary/dggcwlj/user', { "aid": "631ff5bf43b09f005038d8bd", "userinfo": user }, 'post').catch(res => {
                console.log('用户游戏信息测试数据错误', res)
            })
            sessionStorage.setItem("GAME_USERINFO", JSON.stringify(usrdata))
            this.status = true

        }
    }

})
export default class Home extends Vue { }
